import angular from 'angular'

import { wrap, uniqueId, isFunction, isObjectLike } from 'lodash-es'

import envRaw from '../utils/env-raw'
import MapSimple from '../utils/map-simple'

import Template from './gallery-campaign.component.ejs'

angular
  .module('ggs.gallery-campaign')
  .component('ggsGalleryCampaign', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryCampaignComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<',
      ggsPopupOpenHandler: '<',
      ggsPopupClosedHandler: '<',
      ggsCampaignAttachCallback: '<'
    }
  })

const WIDGET_NAME = 'Gleam'

function GalleryCampaignComponent(
  $log,
  $scope,
  qh,
  addIdPrefix,
  notification,
  DefineMethod,
  DefineHandler,
  GalleryCampaignStyleHandlers) {

  const sign = `galleryCampaign[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = this
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)
  const blockerAttr = addIdPrefix(uniqueId('blocker-'))
  const openWidgets = MapSimple()
  const styleHandlers = GalleryCampaignStyleHandlers(blockerAttr)

  // widget management

  $ctrl.wrapH('openRequestHandler', () => {
    const openFunc = findOpenFunc()

    if (isFunction(openFunc)) {
      openFunc($ctrl.widgetOpenHandler, $ctrl.widgetClosedHandler)
    } else {
      $log.warn(`${sign}#openRequestHandler: skipping!`)
      return notification.warn('Looks like Competition is not assigned!')
    }
  })

  $ctrl.wrapH('widgetOpenHandler', (campaignKey, _popupElm, blockerElm) => {
    const blockerId = uniqueId()
    const blockerQs = `[${blockerAttr}="${blockerId}"]`
    blockerElm.setAttribute(blockerAttr, blockerId)
    openWidgets.set(campaignKey, { blockerQs, blockerElm })
    return $ctrl.ggsPopupOpenHandler(blockerQs)
  })

  $ctrl.wrapH('widgetClosedHandler', (campaignKey) => {
    if (openWidgets.has(campaignKey)) {
      const { blockerQs, blockerElm } = openWidgets.get(campaignKey)
      blockerElm.removeAttribute(blockerAttr)
      openWidgets.del(campaignKey)
      return $ctrl.ggsPopupClosedHandler(blockerQs)
    }
  })

  // extCampaign

  $ctrl.wrapM('extCampaignClose', () => {
    for (const campaignKey of openWidgets.keys()) {
      const closeFunc = findCloseFunc(campaignKey)
      if (closeFunc) {
        closeFunc()
      } else {
        $log.warn(`${sign}#extCampaignClose: the widget has changed its API!`)
      }
    }
  })

  $ctrl.wrapM('extCampaignIsOpen', () => {
    return openWidgets.size() !== 0
  })

  $ctrl.wrapM('extCampaignIsClosed', () => {
    return openWidgets.size() === 0
  })

  // initHandler

  $ctrl.wrapM('attachToParent', () => {
    return $ctrl.ggsCampaignAttachCallback(
      $ctrl.extCampaignClose,
      $ctrl.extCampaignIsOpen,
      $ctrl.extCampaignIsClosed)
  })

  $ctrl.wrapM('attachToStyler',
    qh.makeCatch(
      wrap(styleHandlers, $ctrl.ggsStylerNew.reg),
      wrap(`${sign}#attachToStyler: error halted:`, $log.error)))

  $ctrl.wrapH('$onInit',
    qh.makeJoin(
      $ctrl.attachToParent,
      $ctrl.attachToStyler))

  // destroyHandler

  $ctrl.wrapH('$onDestroy',
    qh.makeJoin(
      $ctrl.extCampaignClose,
      wrap(styleHandlers, $ctrl.ggsStylerNew.release)))

  // helpers

  function findOpenFunc() {
    return findWidgetFunc('openPopupCampaign', $ctrl.ggsProperties.campaign_key)
  }

  function findCloseFunc(campaignKey) {
    return findWidgetFunc('hidePopup', campaignKey)
  }

  function findWidgetFunc(funcPrefix, campaignKey) {
    const funcName = `${funcPrefix}${campaignKey}`
    if (isObjectLike(window[WIDGET_NAME]) && isFunction(window[WIDGET_NAME][funcName])) {
      return window[WIDGET_NAME][funcName]
    } else {
      $log.warn(`${sign}#findWidgetFunc: ${funcName} is not found!`)
      return null
    }
  }
}
